import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';

import UserForm from '../../../../../common/components/UserForm';

import * as ui from '../../../../../redux/actionCreators/sync/ui';
import * as employeesActions from '../../../../../redux/actionCreators/async/employees.js';
import { storeEmployees } from '../../../../../redux/actionCreators/sync/employees';

import { pick } from 'lodash';

@connect((store) => (
  {staticData: store.staticData}),
  {
    createUser: employeesActions.createUser,
    storeEmployees,
    showSnackBar: ui.showSnackBar,
  }
)
export default class CreateUser extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    staticData: PropTypes.object.isRequired,
    showSnackBar: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    storeEmployees: PropTypes.func.isRequired,
    employees: PropTypes.object.isRequired
  }

  constructor() {
    super();
  }

  handleClose = (event) => {
    this.props.onClose && this.props.onClose(event);
  };

  save(formFields) {
    // split up form into 'user' and 'profile' sections
    const profile = {
      user: pick(formFields, ['firstName', 'lastName', 'activeState', 'state', 'email', 'roles']),
      profile: pick(formFields, ['title', 'direct_dial', 'cellphoneNumber', 'defaultRole']),
      categories: formFields.categories || [],
      weight: formFields.weight || null,
    };

    if (!profile.user.roles) {
      profile.user.roles = [2];
    }

    // make API call, save formFields to database
    return this.props.createUser(profile).then((employees) => {
      this.props.storeEmployees(employees);
      this.props.showSnackBar();
    });
  }

  render() {

    return (
      <UserForm
        title={'Add New User'}
        closeFunc={::this.handleClose}
        saveFunc={::this.save}
        employees={this.props.employees}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/User/Create/index.js